import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", as, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, lineClassName = "", delay = 0, start = true, inView = false }) => (
  <motion.span
    className="block"
    initial="hidden"
    {...(inView
      ? { whileInView: "visible", viewport: { once: true, margin: "-60px" } }
      : { animate: start ? "visible" : "hidden" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName}`}
          variants={{ hidden: { y: "115%" }, visible: { y: "0%" } }}
          transition={{ duration: 1.05, delay: delay + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
